(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-item')) {
    class CartItem extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.qtyInput = this.querySelector('[data-qty]');
        this.qtyUpdateButtons = this.querySelectorAll('[data-qty-update]');
        this.removeBtn = this.querySelector('[data-remove-button]');
        this.optionSelectors = this.querySelectorAll('[data-option-select]');
        this.properties = JSON.parse(this.dataset.properties);
        this.soldOutMessage = this.querySelector('[data-sold-out-state]');
        this.bundleMessage = this.querySelector('[data-bundle-message]');
        this.timeout;
        const productJsonObject = this.querySelector('[data-product-json]').innerHTML;

        if(productJsonObject) {
          this.productJson = JSON.parse(productJsonObject);
        }

        if (this.qtyInput) {
          this.qtyUpdateButtons.forEach((button) => {
            button.addEventListener('click', this.updateQuantitySelector.bind(this), {
              signal: this.abortController.signal,
            });
          });
          this.qtyInput.addEventListener('change', this.updateLineQuantity.bind(this), {
            signal: this.abortController.signal,
          });
        }

        if(this.optionSelectors.length > 0) {
          this.optionSelectors.forEach((select) => {
            select.addEventListener('change', this.updateLineVariant.bind(this), {
              signal: this.abortController.signal,
            });
          });
        }

        this.removeBtn.addEventListener('click', this.removeItem.bind(this), {
          signal: this.abortController.signal,
        });

        this.removeAttribute('data-properties');
        this.checkBundleMessage();
      }

      updateLineQuantity() {
        clearTimeout(this.timeout);
        const maxQuantity = this.qtyInput.max;
        const newQty = this.qtyInput.value;
        this.timeout = setTimeout(() => {
          window.storeModule.dispatch('updateQuantities', {
            [this.dataset.itemId]: Math.min(newQty, maxQuantity),
          });
        }, 500)
      }

      updateQuantitySelector(evt) {
        const direction = evt.srcElement.dataset.qtyUpdate;
        const quantity = parseInt(this.qtyInput.value);
        const maxQuantity = this.qtyInput.max;

        if (direction == 'increase') {
          this.qtyInput.value = Math.min(quantity + 1, maxQuantity);
        } else {
          this.qtyInput.value = Math.max(quantity - 1, 0);
        }

        this.qtyInput.dispatchEvent(new CustomEvent('change', { bubbles: true }));
      }

      updateLineVariant(evt) {
        const selectedOptions = Array.from(this.optionSelectors).map(option => option.value);
        const newVariant = this.productJson.variants.find((variant) => {
          return selectedOptions.every((option) => {
            return variant.options.includes(option);
          })
        })
        const quantity = parseInt(this.qtyInput.value) > newVariant.inventory ? newVariant.inventory : parseInt(this.qtyInput.value);
        let properties = {};

        if(this.properties) {
          properties = {
            ...properties,
            ...this.properties,
          }
        }

        if(newVariant.available == false) {
          this.toggleSoldOutState(true);
          return;
        }

        this.toggleSoldOutState(false);

        store.dispatch('swapItem', {
          itemToRemove: {
            id: this.dataset.itemId,
            properties: properties
          },
          itemToAdd: {
            id: newVariant.id,
            quantity: quantity
          },
          maxQuantity: newVariant.inventory
        })
      }

      toggleSoldOutState(state) {
        console.log(this.soldOutMessage);
        this.soldOutMessage.classList.toggle('hidden', !state)
      }

      removeItem() {
        window.storeModule.dispatch('updateQuantities', {
          [this.dataset.itemId]: 0,
        });
      }

      checkBundleMessage() {
        const bundleMessages = window.bundle_messages;
        const productCollections = this.dataset.collections;

        const currentMessage = bundleMessages.find((message) => {
          let hasCollection = message.applicable_collection.some((loopCollection) => {
            return productCollections.includes(loopCollection);
          })

          let hasProduct = message.applicable_product.includes(this.dataset.productId);

          return hasCollection || hasProduct;
        })

        if(currentMessage) {
          this.bundleMessage.classList.remove('hidden');
          this.bundleMessage.innerText = currentMessage.message;
        } else {
          this.bundleMessage.classList.add('hidden');
          this.bundleMessage.innerText = "";
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('cart-item', CartItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cart-notification')) {
    class CartNotification extends HTMLElement {
      constructor() {
        super()

        this.notification = document.getElementById('cart-notification')
        this.header = document.querySelector('sticky-header')
        this.onBodyClick = this.handleBodyClick.bind(this)

        this.notification.addEventListener(
          'keyup',
          (evt) => evt.code === 'Escape' && this.close()
        )
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
          closeButton.addEventListener('click', this.close.bind(this))
        )
      }

      open() {
        this.notification.classList.add('animate', 'active')

        this.notification.addEventListener(
          'transitionend',
          () => {
            this.notification.focus()
            trapFocus(this.notification)
          },
          { once: true }
        )

        document.body.addEventListener('click', this.onBodyClick)
      }

      close() {
        this.notification.classList.remove('active')

        document.body.removeEventListener('click', this.onBodyClick)

        removeTrapFocus(this.activeElement)
      }

      renderContents(parsedState) {
        this.productId = parsedState.id
        this.getSectionsToRender().forEach((section) => {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          )
        })

        this.header?.reveal()
        this.open()
      }

      getSectionsToRender() {
        return [
          {
            id: 'cart-notification-product',
            selector: `#cart-notification-product-${this.productId}`,
          },
          {
            id: 'cart-icon-bubble',
          },
        ]
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML
      }

      handleBodyClick(evt) {
        const target = evt.target
        if (target !== this.notification && !target.closest('cart-notification')) {
          const disclosure = target.closest('details-disclosure')
          this.activeElement = disclosure
            ? disclosure.querySelector('summary')
            : null
          this.close()
        }
      }

      setActiveElement(element) {
        this.activeElement = element
      }
    }

    customElements.define('cart-notification', CartNotification)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-form-container"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('contact-form-container')) {
  class ContactFormContainer extends HTMLElement {
    constructor() {
      super()

      this.querySelector('button[type="submit"]')?.addEventListener(
        'click',
        this.onSubmitHandler.bind(this)
      )

      const inputs = this.querySelectorAll('input')
      inputs.forEach((el) => {
        el.addEventListener('keypress', (e) => {
          if (e.keyCode == 13) {
            this.onSubmitHandler(e)
          }
        })
      })

      const selects = this.querySelectorAll('select')
      selects.forEach((el) => {
        el.addEventListener('change', (e) => {
          if (el.value) {
            el.classList.add('filled')
          } else {
            el.classList.remove('filled')
          }
        })
      })
    }

    onSubmitHandler(e) {
      e.preventDefault()
      e.stopPropagation()

      this.formValidation()
    }

    formValidation () {
      const form = this.querySelector('form')

      if (form) {
        const inputs = this.querySelectorAll('input.required:not([type="hidden"]), select.required, textarea.required')
        const fieldsets = this.querySelectorAll('fieldset.required');
        var allValidated = true;

        inputs.forEach((el) => {
          if (el.value) {
            el.closest('.field').classList.remove('error')
          } else {
            allValidated = false
            el.closest('.field').classList.add('error')
          }
        })

        if(fieldsets.length) {
          fieldsets.forEach((fieldset) => {
            const checkboxes = Array.from(fieldset.querySelectorAll('input[type="checkbox"]'));
            const fieldError = fieldset.querySelector('.field__label__error');

            const anyChecked = checkboxes.find((checkbox) => checkbox.checked);

            if(!anyChecked) {
              allValidated = false;
              fieldset.classList.add('error');
              fieldset.setAttribute('aria-describedby', fieldError.id);
              fieldset.setAttribute('aria-invalid', true);
            } else {
              fieldset.classList.remove('error');
              fieldset.removeAttribute('aria-descrbedby');
              fieldset.removeAttribute('aria-invalid');

            }
          })
        }

        if (allValidated) {
          form.submit()
        }
      }
    }
  }

  customElements.define('contact-form-container', ContactFormContainer)
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-notice"] && !Shopify.designMode) return;
  try {
    const IS_VISIBLE = 'is-visible'

  const cookieModal = document.querySelector('.js-cookie-notice')

  if(!cookieModal) return;

  const cookieAcceptBtn = cookieModal.querySelector('.js-cookie-btn')


  const consentCheckValidation = function () {
    if(window.Shopify.customerPrivacy) {
      checkConsent();
    } else {
      setTimeout(() => {
        consentCheckValidation();
      }, 100);
    }
  }

  const checkConsent = function () {
    let currentConsentStatus = window.Shopify.customerPrivacy.currentVisitorConsent();
    let showCookieBanner = ["marketing", "analytics", "preferences"].some((checkValue) => {
      return currentConsentStatus[checkValue] == "";
    })

    if (showCookieBanner) {
      cookieModal.classList.add(IS_VISIBLE);
      return;
    }
  }

  cookieAcceptBtn.addEventListener('click', function () {
    cookieModal.classList.remove(IS_VISIBLE)
    window.Shopify.customerPrivacy.setTrackingConsent({
      "analytics": true,
      "marketing": true,
      "preferences": true,
    })
  })
  document.addEventListener('DOMContentLoaded', () => {
    consentCheckValidation();
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('localization-form-new')) {
    customElements.define(
      'localization-form-new',
      class LocalizationFormNew extends HTMLElement {
        constructor() {
          super();
          this.customId = crypto.randomUUID();
          this.retries = 0;
          this.selectorForm = this.querySelector('form');
          this.toggler = this.querySelector('[data-localization-dropdown-toggler]');
          this.dropdown = this.querySelector('[data-localization-dropdown]');
          this.languageSelect = this.querySelector('select[name="language_code"]');
          this.languageCustomSelect = this.querySelector('[data-language-options]');
          this.languageToggler = this.querySelector('[data-language-dropdown-toggler]');
          this.countryToggler = this.querySelector('[data-country-dropdown-toggler]');
          this.languageFlag = this.querySelector('[data-language-flag]');

          this.customSelect = this.querySelectorAll('custom-select');

          this.toggler.addEventListener('click', this.onTogglerClick.bind(this));
          this.customSelect.forEach((customSelect) => {
            this.enableCustomSelect(customSelect);
          })

          this.selectorForm.addEventListener('submit', this.onSwitcherSubmit.bind(this));

          document.addEventListener('DOMContentLoaded',  () => {
            this.setLanguageOptions();
            this.setLanguageChangeListener();
          });
          this.selectorForm.removeAttribute('id');
          this.toggler.setAttribute('aria-controls', 'dropdown-'+this.customId);
          this.dropdown.id = 'dropdown-'+this.customId;
        }

        onTogglerClick(evt) {
          evt.preventDefault();

          if(this.toggler.ariaExpanded == 'true') {
            this.closeDropdown();
          } else {
            this.openDropdown();
          }
        }

        async klaviyoRegisterLanguage(lang) {
          if(window.klaviyo) {
            const langObject = {
              "language": lang
            }
            if(window.customer.email) {
              langObject.email = window.customer.email
            }

            await klaviyo.identify(langObject);
          }
        }

        async registerAttentiveLanguage(lang) {
          if(!window.customer.email) return;
          const customerEmail = window.customer.email;
          const customerConsent = Shopify.customerPrivacy.currentVisitorConsent();
          if(customerConsent.preferences = 'yes') {
            await fetch(
              "https://hook.us1.make.com/vchwf94yk6uhn7vsov49xe407hrn5h2u",
              {
                method: "post",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  "email": customerEmail,
                  "language": lang
                })
              }
            );
          }
        }


        onSwitcherSubmit(evt) {
          evt.preventDefault();
          evt.stopPropagation();

          const formData = new FormData(this.selectorForm);
          const selectedCountryCode = formData.get('country_code').toLowerCase();
          const selectedLanguageCode = formData.get('language_code').toLowerCase();

          this.klaviyoRegisterLanguage(selectedLanguageCode);
          this.registerAttentiveLanguage(selectedLanguageCode);

          if(this.selectorForm.dataset.enableUrlRewrite == 'true') {
            const targetRoot = this.getTargetRoot({
              countryCode: selectedCountryCode,
              languageCode: selectedLanguageCode
            })

            if(targetRoot == Shopify.routes.root) {
              this.closeCustomSelectDropdown();
              return;
            }
            if(targetRoot == "/") {
              document.location.href = document.location.origin + document.location.pathname.replace(Shopify.routes.root.replaceAll('/', ''), "")
              return;
            }

            if(Shopify.routes.root !== '/') {
              document.location.href = document.location.origin + document.location.pathname.replace(Shopify.routes.root.replaceAll('/', ''), `${targetRoot}`).replace('//', '/')
              return;
            }

            document.location.href = document.location.origin + "/" + targetRoot + "/" + document.location.pathname;
          } else {
            const currentLanguageCode = Weglot.getCurrentLang();

            if(currentLanguageCode !== selectedLanguageCode) {
              Weglot.switchTo(selectedLanguageCode);
              this.closeDropdown();
            }

            if(Shopify.country.toLowerCase() !== selectedCountryCode) {
              setTimeout(() => {
                this.selectorForm.submit();
              }, 1000)
            }
          }
        }

        getTargetRoot({countryCode, languageCode}) {
          let targetRoot = "/";

          if(countryCode !== "us") {
            return `${languageCode}-${countryCode}`
          }

          if(languageCode !== "en") {
            return `${languageCode}`
          }

          return targetRoot;
        }

        openDropdown() {
          this.dropdown.removeAttribute('hidden');
          this.toggler.ariaExpanded = "true";
        }

        closeDropdown() {
          this.dropdown.setAttribute('hidden', true);
          this.toggler.ariaExpanded = "false";
        }

        setLanguageOptions() {
          if(this.retries == 100) {
            console.error('[Localization Form] - Retried 100 times, stop recursive calling');
            return;
          }

          if(!window.Weglot?.initialized) {
            this.retries += 1;
            setTimeout(() => {
              this.setLanguageOptions();
            }, 300);
            return;
          }

          this.languageToggler.querySelector('[data-selected-text]').innerText = window.Weglot.getLanguageName(window.Weglot.getCurrentLang());
          this.languageFlag.innerText = window.Weglot.getCurrentLang().toUpperCase();
          const languages = window.Weglot.options.languages.map((language) => language.language_to);
          languages.unshift(window.Weglot.options.language_from);

          languages.forEach((language) => {
            const option = document.createElement('option');
            option.value = language;
            option.text = window.Weglot.getLanguageName(language);
            if(language == window.Weglot.getCurrentLang()) {
              option.selected = true;
            }
            this.languageSelect.appendChild(option);

            const customOption = document.createElement('li');
            customOption.setAttribute('value', language);
            customOption.innerText = window.Weglot.getLanguageName(language);
            customOption.classList.add('custom-select__option');

            if(language == window.Weglot.getCurrentLang()) {
              customOption.setAttribute('aria-current', true);
            }

            this.languageCustomSelect.appendChild(customOption);
            this.languageToggler
          })
        }

        setLanguageChangeListener() {
          const scopedLangFlag = this.languageFlag;
          if(this.retries == 100) {
            console.error('[Localization Form] - Retried 100 times, stop recursive calling');
            return;
          }

          if(!window.Weglot?.initialized) {
            this.retries += 1;
            setTimeout(() => {
              this.setLanguageChangeListener();
            }, 300);
            return;
          }

          Weglot.on('languageChanged', function(lang) {
            scopedLangFlag.innerText = lang.toUpperCase();
          })
        }

        enableCustomSelect(customSelect) {
          const randomId = crypto.randomUUID();
          const togglerButton = customSelect.querySelector('[data-custom-select-toggler]');
          const regularSelect = customSelect.querySelector('select');
          const customSelectDropdown = customSelect.querySelector('[data-custom-select-options]');

          togglerButton.setAttribute('aria-controls', 'dropdown-' + randomId);
          customSelectDropdown.id = 'dropdown-' + randomId;

          customSelectDropdown.addEventListener('click', (evt) => {
            regularSelect.value = evt.srcElement.getAttribute('value');
            regularSelect.dispatchEvent(new Event('change'));
          })

          regularSelect.addEventListener('change', (evt) => {
            const customValues = customSelectDropdown.querySelectorAll('li');
            customValues.forEach((element) => {
              if(element.getAttribute('value') == evt.target.value) {
                element.setAttribute('aria-current', true);
                togglerButton.querySelector('[data-selected-text]').innerHTML = element.innerHTML;
              } else {
                element.removeAttribute('aria-current');
              }
            })
            this.closeCustomSelectDropdown(togglerButton, customSelectDropdown);
          })

          togglerButton.addEventListener('click', (evt) => {
            if(togglerButton.ariaExpanded == 'true') {
              this.closeCustomSelectDropdown(togglerButton, customSelectDropdown);
            } else {
              this.openCustomSelectDropdown(togglerButton, customSelectDropdown);

            }
          })
        }

        openCustomSelectDropdown(togglerButton,dropdown) {
          dropdown.removeAttribute('hidden')
          togglerButton.setAttribute('aria-expanded', 'true');
        }

        closeCustomSelectDropdown(togglerButton,dropdown) {
          dropdown.setAttribute('hidden', true)
          togglerButton.setAttribute('aria-expanded', 'false');
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-cart"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('main-cart')) {
    class MainCart extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.abortController = new AbortController();
        this.connectWithStoreModule();
        this.cartDrawerToggler = document.querySelector('[data-cart-drawer-toggle]');
        this.cartCountEls = document.querySelectorAll('[data-cart-title-count]');
        this.nostoModule = this.querySelector('.nosto_element');
        this.packagingCheckbox = this.querySelector('[data-packaging-checkbox]');

        const itemsCount = this.dataset.itemCount;

        this.cartCountEls.forEach((countEl) => {
          if(itemsCount > 0) {
            countEl.classList.remove('hidden');
            countEl.innerText = itemsCount
            if(this.cartDrawerToggler) {
              this.cartDrawerToggler.classList.add('filled');
            }
          } else {
            countEl.innerText = "";
            countEl.classList.add('hidden');
            if(this.cartDrawerToggler) {
              this.cartDrawerToggler.classList.remove('filled');
            }
          }
        })
        if(this.packagingCheckbox) {
          this.packagingCheckbox.addEventListener('change', this.onPackagingChange.bind(this), {
            signal: this.abortController.signal
          })
        }
      }

      connectWithStoreModule() {
        if(this.storeModule) return;
        if(window.storeModule?.events) {
          this.storeModule = window.storeModule;
          this.storeModule.events.subscribe('cartLoadingChange', this.cartLoading.bind(this));
          this.storeModule.events.subscribe('cartChange', this.render.bind(this));
          this.validateFreeGift();
        } else {
          setTimeout(() => {
            this.connectWithStoreModule();
          }, 500);
        }
      }

      render() {
        const parsedSection = new DOMParser()
        .parseFromString(this.storeModule.state.cart.sections[this.id], 'text/html')

        this.replaceWith(parsedSection.querySelector('main-cart'));
        this.validateFreeGift();
        if(this.nostoModule) {
          nostojs(api => {
              api.createRecommendationRequest({includeTagging:true})
                .setElements([this.nostoModule.id])
                .load()
            }
          );
        }
      }

      cartLoading(loading) {
        if(loading) {
          this.style.opacity = 0.3;
          this.style.pointerEvents = "none";
        } else {
          this.style.opacity = 1;
          this.style.removeProperty('pointer-events');
        }
      }

      validateFreeGift() {
        if(!this.parentElement) return;

        const freeGiftDataEl = this.parentElement.querySelector('[data-sxgy]');

        if(freeGiftDataEl) {
          const freeGiftData = JSON.parse(freeGiftDataEl.innerHTML);
          const cartInfo = this.storeModule.state.cart;
          const freeGiftItem = cartInfo.items.find((lineItem) => {
            return lineItem.properties.hasOwnProperty('_sxgy');
          })

          if(cartInfo.total_price > freeGiftData.threshold) {
            if(freeGiftItem == null) {
              this.storeModule.dispatch('addItems', {
                [freeGiftData.id]: {
                  properties: {
                    "_sxgy": "true"
                  },
                  quantity: 1
                }
              })
            }
          } else if (freeGiftItem) {
            this.storeModule.dispatch('updateQuantities', {
              [freeGiftItem.key]: 0
            })
          }
        }
      }

      onPackagingChange() {
        const productId = this.packagingCheckbox.dataset.id
        if(this.packagingCheckbox.checked) {
          this.storeModule.dispatch('addItems', {
            [productId]: {
              quantity: 1
            }
          })
        } else {
          this.storeModule.dispatch('updateQuantities', {
            [productId]: 0,
          })
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('main-cart', MainCart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["modal-window"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('modal-window')) {
  class ModalWindow extends HTMLElement {
    constructor() {
      super();
      this.referrer = null;
    }

    connectedCallback() {
      this.abortController = new AbortController();
      this.overlay = this.querySelector('[data-overlay]');
      this.closeButton = this.querySelector('[data-close-button]');
      this.section = this.closest('.shopify-section');

      this.overlay.addEventListener('click', this.closeModal.bind(this), {signal: this.abortController.signal});
      this.closeButton.addEventListener('click', this.closeModal.bind(this), {signal: this.abortController.signal});
      this.addEventListener('keyup', this.onKeyUp.bind(this), {signal: this.abortController.signal});
    }

    onKeyUp(evt) {
      if(evt.key == 'Escape') {
        this.closeModal();
      }
    }

    openModal(referrer) {
      this.style.removeProperty('display');
      setTimeout(() => {
        this.classList.add('visible');
      }, 10);
      window.bodyScrollLock.disableBodyScroll(this);
      if(referrer) {
        this.referrer = referrer;
      }
    }

    closeModal() {
      this.addEventListener('transitionend', () => {
        this.style.setProperty('display', "none");
      }, {once: true})

      this.classList.remove('visible');

      window.bodyScrollLock.enableBodyScroll(this);
      if(this.referrer) {
        this.referrer.focus();
      }
    }

    disconnectedCallback() {
      this.abortController.abort();
    }
  }

  customElements.define('modal-window', ModalWindow);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nosto-carousel-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nosto-recommendation-slider')) {
    class NostoRecommendationSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.title = this.dataset.title;
        this.products = this.dataset.products;
        this.recId = this.dataset.id;
        this.isMiniCart = !!this.closest('cart-drawer') || false;
        this.isCompleteLook = this.parentElement.parentElement.dataset.completelook || false;
        this.placeholder = this.closest('.nosto-slider-wrapper').querySelector('.nosto-slider-skeleton');
        this.productsArray = this.products.split(',');

        this.buildLayout();
      }

      buildLayout() {
        const productSlides = this.buildProductSlides();
        let layout = `
          <h2 class="section-title">${this.title}</h2>
          <div class="slide-wrap">
            <div class="nosto-slider" id="collection-slider-${this.recId}">
              ${productSlides.join('')}
            </div>
          </div>
        `;

        this.innerHTML = layout;
        this.placeholder?.remove();
        this.sliderContainer = this.querySelector('.nosto-slider');
        this.initSlider();
      }

      buildProductSlides() {
        return this.productsArray.map((product) => {
          if(product != '') {
            return `<div class="data-slide">
              <v3-product-card
                data-url="${product}"
                class="skeleton-item"
                data-hide-swatches="true"
                data-show-condensed-atc="${this.isMiniCart}"
                data-hide-quick-buy="${this.isMiniCart}"
                data-hide-quick-view="${this.isMiniCart}"
                data-rec-id="${this.recId}"
                >
              </v3-product-card>
            </div>`;
          }
        });
      }

      initSlider() {
        let sliderSettings = {
          autoWidth: false,
          items: 5,
          gutter: 25,
          slideBy: 4,
          mouseDrag: true,
          swipeAngle: false,
          container: this.sliderContainer,
          speed: 400,
          edgePadding: 150,
          loop: false,
          responsive: {
            1200: {
              items: 5,
              edgePadding: 100,
              slideBy: 4,
            },
            850: {
              items: 4,
              edgePadding: 50,
              slideBy: 3,
            },
            768: {
              items: 3,
              edgePadding: 50,
              slideBy: 3,
            },
            500: {
              items: 2,
              edgePadding: 50,
              gutter: 15,
              slideBy: 2,
            },
            100: {
              items: 2,
              edgePadding: 30,
              gutter: 15,
              slideBy: 2,
            },
          },
        };

        if(this.isMiniCart) {
         sliderSettings = {
          ...sliderSettings,
          "items": 2,
          "slideBy": 2,
          "edgePadding": 50,
          "responsive": {
              768: {
                  items: 2,
                  "edgePadding": 50,
                  "slideBy": 1,
                  "gutter": 25
              },
              100: {
                  items: 2,
                  "edgePadding": 50,
                  "gutter": 15,
                  "slideBy": 1
              }
          }
         }
        }

        if(this.isCompleteLook == "true") {
          sliderSettings = {
            ...sliderSettings,
            preventScrollOnTouch: "auto",
            responsive: {
              990: {
                  "items": 4,
                  "edgePadding": 0,
                  "slideBy": 2,
                  "gutter": 25
              },
              768: {
                  "items": 3,
                  "edgePadding": 0,
                  "slideBy": 2,
                  "gutter": 25
              },
              100: {
                  "items": 2,
                  "edgePadding": 0,
                  "gutter": 15,
                  "slideBy": 2
              }
            }
          }
        }

        this.slider = tns(sliderSettings);
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('nosto-recommendation-slider', NostoRecommendationSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("v3-product-card")) {
    const IMAGE_SIZES = [
      48, 85, 90, 112, 256, 320, 360, 480, 640, 750, 828, 1080, 1200, 1920,
      2048, 3840,
    ];

    class V3ProductCards extends HTMLElement {
      constructor() {
        super();
        this.io = new IntersectionObserver(this.observerCallback.bind(this), {
          rootMargin: "900px",
          threshold: 0.01,
        });
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.isPreloaded = !this.dataset.url;
        this.currentVariant = null;
        this.loading = this.dataset.loading;
        this.hideSwatches = this.dataset.hideSwatches == 'true';
        this.hideQuickBuy = this.dataset.hideQuickBuy == 'true';
        this.hideQuickView = this.dataset.hideQuickView == 'true';
        this.showCondensedAtc = this.dataset.showCondensedAtc == 'true';
        this.recId = this.dataset.recId;

        if (this.isPreloaded) {
          this.initCard();
        } else {
          this.io.observe(this);
        }
        this.mouseLeaveTimeout;
      }

      observerCallback(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting == true) {
            this.getCardUI();
          }
        });
      }

      async getCardUI() {
        const productUrl = new URL(this.dataset.url);
        productUrl.searchParams.append("view", "card");

        const req = await fetch(productUrl, {
          method: "get",
        });

        const res = await req.text();

        this.io.disconnect();

        this.innerHTML = res;

        this.initCard();
      }

      initCard() {
        let familyDataObject = this.querySelector("[data-product-family]");
        this.classList.remove("skeleton-item");
        this.productObject = JSON.parse(
          this.querySelector("[data-product-json]").textContent
        );
        this.isOuterworn = this.productObject.title.toLowerCase().includes('outerworn');

        this.quickAddForm = this.querySelector("[data-quick-add-form]");
        this.variantButtonsContainer = this.querySelector(
          "[data-variant-buttons-container]"
        );
        this.variantSelect = this.querySelector("[data-variant-select]");
        this.productBadge = this.querySelector("[data-product-badge]");
        this.regularPrice = this.querySelector("[data-regular-price]");
        this.comparePrice = this.querySelector("[data-compare-price]");
        this.discountMessage = this.querySelector("[data-discount-message]");
        this.regularForm = this.querySelector(".product-card__form");
        this.productUrl = this.querySelectorAll("[data-product-url]");
        this.bisFormTrigger = this.querySelector("[data-bis-form-trigger]");
        this.atcCondensed = this.querySelector(
          ".product-card__condensed-quick-buy"
        );
        this.cardSwatches = this.querySelector("[data-card-swatches]");
        this.mediaContainer = this.querySelector('.product-card__images');
        this.mainImage = this.querySelector("[data-main-image]");
        this.hoverImge = this.querySelector("[data-hover-image]");
        this.hoverVideo = this.querySelector("[data-hover-video]");
        this.bundleMessage = this.querySelector('[data-bundle-message]');
        this.quickViewButton = this.querySelector('[data-quick-view-button]');

        if (familyDataObject) {
          this.productFamilyObject = JSON.parse(familyDataObject.textContent);
        }

        this.initCardEvents();

        this.updateProductUrl(this.productObject);
        this.updateProductPrice(this.productObject);
        this.updateProductImages(this.productObject);
        this.updateBundleMessage(this.productObject);
        this.updateATCMethods();


        if (this.regularForm) {
          this.updateProductQuickAdd(this.productObject);
        }

        if(this.hideQuickView) {
          this.quickViewButton.remove();
        } else {
          if(this.quickViewButton) {
            this.quickViewButton.addEventListener('click', this.onQuickViewClick.bind(this));
          }
        }

        this.mediaContainer.addEventListener('mouseenter', this.onMediaMouseEnter.bind(this));
        this.mediaContainer.addEventListener('mouseleave', this.onMediaMouseLeave.bind(this));
      }

      onQuickViewClick(evt) {
        evt.preventDefault();
        const template = this.querySelector(`[data-quick-view-template]`).content.cloneNode(true);
        const modalBody = template.querySelector('.modal-window__body');
        const referrerText = evt.target.innerText;
        const optionColor = this.productObject.options.find((option) => {
          return option.name.toLowerCase() == 'color'
        })

        evt.target.innerText = "Loading...";

        document.dispatchEvent(new CustomEvent('quick-view:open-modal', { detail: {
          referrer: evt.target,
          referrerText: referrerText,
          recId: this.recId,
          body: modalBody,
          color: optionColor.values[0],
        }}))
      }

      initCardEvents() {
        this.hoveredCheckbox = null;
        if (this.cardSwatches && !this.hideSwatches) {
          this.cardSwatches.addEventListener(
            "change",
            this.onVariantChange.bind(this),
            {
              signal: this.abortController.signal,
            }
          );
        }
        if (this.bisFormTrigger) {
          this.bisFormTrigger.addEventListener(
            "click",
            this.onBisTriggerClick.bind(this),
            {
              signal: this.abortController.signal,
            }
          );
          this.bisFormTrigger.addEventListener(
            "mouseenter",
            this.onBisButtonMouseEnter.bind(this),
            {
              signal: this.abortController.signal,
            }
          );
          this.bisFormTrigger.addEventListener(
            "mouseleave",
            this.onBisButtonMouseLeave.bind(this),
            {
              signal: this.abortController.signal,
            }
          );
        }
        if (this.regularForm) {
          this.regularForm.addEventListener(
            "change",
            this.onQuickAddSelectChange.bind(this),
            {
              signal: this.abortController.signal,
            }
          );
          this.regularForm.addEventListener(
            "mouseover",
            this.onOptionMouseEnter.bind(this),
            {
              signal: this.abortController.signal,
            }
          );
          this.regularForm.addEventListener(
            "mouseout",
            this.onOptionMouseLeave.bind(this),
            {
              signal: this.abortController.signal,
            }
          );
        }
        if (this.atcCondensed) {
          this.atcCondensed.addEventListener(
            "change",
            this.atcCondensedOptionChange.bind(this)
          );
          this.atcCondensed.addEventListener(
            "submit",
            this.atcCondensedSubmit.bind(this)
          );
          this.atcCondensedOptionChange();
        }
      }

      atcCondensedSubmit(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const id = this.atcCondensed.querySelector('[name="id"]').value;

        window.store.dispatch(
          "addItems",
          {
            [id]: 1,
          },
          true
        );

        nostojs(api => {
          api.recommendedProductAddedToCart(id, this.recId);
        })
      }

      atcCondensedOptionChange() {
        const availableOptions = this.getActiveOptions();
        const productOptions = this.atcCondensed.querySelectorAll(
          "[data-variant-option]"
        );
        productOptions.forEach((option) => {
          const optionKey = option.dataset.variantOption;
          const optionValue = option.value;

          if (availableOptions[optionKey].has(optionValue)) {
            option.removeAttribute("disabled");
          } else {
            option.setAttribute("disabled", true);
          }
        });

        this.atcCondensed.querySelector('[name="id"]').value =
          this.activeVariant.id;

        if (this.activeVariant.available) {
          this.atcCondensed
            .querySelector(".product-card__condensed-quick-buy-btn")
            .removeAttribute("disabled");
        } else {
          this.atcCondensed
            .querySelector(".product-card__condensed-quick-buy-btn")
            .setAttribute("disabled", true);
        }
      }

      getActiveOptions() {
        const currentOptions = Array.from(
          this.atcCondensed.querySelectorAll("[data-option-position]")
        );
        const selectedValues = currentOptions.map((option) => option.value);
        let activeVariant = null;

        const optionMap = {
          option1: new Set(),
          option2: new Set(),
          option3: new Set(),
        };

        const enabledMap = {
          option1: new Set(),
          option2: new Set(),
          option3: new Set(),
        };

        this.productObject.variants.forEach((variant) => {
          if (variant && variant.option1)
            optionMap.option1.add(variant.option1);
          if (variant && variant.option2)
            optionMap.option2.add(variant.option2);
          if (variant && variant.option3)
            optionMap.option3.add(variant.option3);

          if (variant.options.join(" ") == selectedValues.join(" ")) {
            activeVariant = variant;
          }
        });

        ["option1", "option2", "option3"].forEach((optionKey) => {
          if (optionMap[optionKey].size === 0) return;

          for (const optionValue of optionMap[optionKey]) {
            const testSelection = {
              option1: selectedValues[0],
              option2: selectedValues[1],
              option3: selectedValues[2],
            };

            testSelection[optionKey] = optionValue;

            const matchingVariant = this.productObject.variants.find(
              (loopVariant) =>
                (!testSelection.option1 ||
                  loopVariant.option1 === testSelection.option1) &&
                (!testSelection.option2 ||
                  loopVariant.option2 === testSelection.option2) &&
                (!testSelection.option3 ||
                  loopVariant.option3 === testSelection.option3)
            );

            if (matchingVariant && matchingVariant.available) {
              enabledMap[optionKey].add(optionValue);
            }
          }
        });

        this.activeVariant = activeVariant;

        return enabledMap;
      }

      onVariantChange(evt) {
        this.productObject = this.productFamilyObject[evt.target.value];

        this.updateProductBadge(this.productObject);
        this.updateProductImages(this.productObject);
        this.updateProductPrice(this.productObject);
        this.updateProductUrl(this.productObject);
        this.updateProductQuickAdd(this.productObject);
        this.updateQuickViewButton(this.productObject);
      }

      updateQuickViewButton(productObject) {
        this.quickViewButton.setAttribute('data-quick-view-product', productObject.url);
        this.updateBundleMessage(productObject);
      }

      updateProductBadge(productObject) {
        const newBadge = productObject.tags.find(
          (badge) => badge.indexOf("collection_bd:") > -1
        );
        if (newBadge) {
          this.productBadge.innerText = newBadge.replace("collection_bd:", "");
          this.productBadge.removeAttribute("style");
        } else {
          this.productBadge.style.display = "none";
        }
      }

      updateBundleMessage(productObject) {
        const messageObject = window.bundle_messages.find((messageObject) => {
          const hasCollection = messageObject.applicable_collection.some((loopCollection) => {
            return productObject.collections.includes((loopCollection))
          })

          const hasProduct = messageObject.applicable_product.some((loopProduct) => productObject.id === loopProduct);
          return hasCollection || hasProduct;
        })

        if(messageObject) {
          this.bundleMessage.classList.remove('hidden');
          this.bundleMessage.innerText = messageObject.message;
        } else {
          this.bundleMessage.classList.add('hidden');
          this.bundleMessage.innerText = "";
        }
      }

      updateATCMethods() {
        if(this.hideQuickBuy || this.isOuterworn) {
          this.regularForm?.remove();
          this.regularForm = null;
        }

        if(this.hideQuickView || this.isOuterworn) {
          this.quickViewButton.remove()
          this.quickViewButton = null;
        }

        if(this.hideSwatches || this.isOuterworn) {
          this.cardSwatches.remove();
          this.cardSwatches = null;
        }

        if(this.showCondensedAtc) {
          this.atcCondensed.classList.remove('hidden');
        }
      }

      updateProductImages(productObject) {
        let mainImageIndex = 0;
        let hoverImageIndex = 1;

        if (this.loading == "eager") {
          this.mainImage.loading = "eager";
          this.mainImage.fetchPriority = "high";
        }

        if (this.dataset.gendered) {
          const genderLabel = `${this.dataset.gendered}_gendered_images`;
          mainImageIndex = productObject.metafields[genderLabel].main
            ? productObject.metafields[genderLabel].main
            : 0;
          hoverImageIndex = productObject.metafields[genderLabel].hover
            ? productObject.metafields[genderLabel].hover
            : 1;
        }

        if (!this.mainImage) return;
        this.mainImage.src = productObject.images[mainImageIndex].url;
        this.mainImage.alt = productObject.images[mainImageIndex].alt;
        this.mainImage.srcset = IMAGE_SIZES.map(
          (size) =>
            `${productObject.images[mainImageIndex].url}&width=${size} ${size}w`
        ).join(", ");

        this.hoverImge.src = productObject.images[hoverImageIndex].url;
        this.hoverImge.alt = productObject.images[hoverImageIndex].alt;
        this.hoverImge.srcset = IMAGE_SIZES.map(
          (size) =>
            `${productObject.images[hoverImageIndex].url}&width=${size} ${size}w`
        ).join(", ");

        if(productObject.metafields.plp_desktop_video || productObject.metafields.plp_mobile_video) {
          let mediaVideos = [];

          mediaVideos.push(`<source
            src="${productObject.metafields.plp_desktop_video[0].src}"
            type="${productObject.metafields.plp_desktop_video[0].mime_type}"
            ${productObject.metafields.plp_mobile_video[0] ? 'media="(min-width: 992px)"': ''}
            >`)

          mediaVideos.push(`<source
            src="${productObject.metafields.plp_mobile_video[0].src}"
            type="${productObject.metafields.plp_mobile_video[0].mime_type}"
            ${productObject.metafields.plp_desktop_video[0] ? 'media="(max-width: 991px)"': ''}
          >`)

          this.hoverVideo.classList.add('active');
          this.hoverVideo.innerHTML = mediaVideos.join('');
          this.hoverVideo.load();
        } else {
          this.hoverVideo.classList.remove('active');
        }
      }

      updateProductPrice(productObject) {
        this.regularPrice.innerText = Shopify.formatMoney(
          productObject.price,
          window._moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}')
        );

        if (productObject.compare_at_price > productObject.price) {
          this.comparePrice.innerText = Shopify.formatMoney(
            productObject.compare_at_price,
            window._moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}')
          );
          this.comparePrice.removeAttribute("style");
        } else {
          this.comparePrice.style.display = "none";
        }

        //Check for custom promotional messages
        if (sessionStorage.getItem("discountMessage") != null) {
          if (
            productObject.collections?.includes(
              sessionStorage.getItem("applicableCollection")
            )
          ) {
            this.discountMessage.innerText =
              sessionStorage.getItem("discountMessage");
            this.discountMessage.removeAttribute("style");
          }
          return;
        }

        if (window.promoMessages.length > 0) {
          const promoObject = window.promoMessages.find((messageObject) =>
            productObject.collections?.includes(messageObject.allowedCollection)
          );

          if (promoObject) {
            this.discountMessage.innerText = promoObject.promoMessage;
            this.discountMessage.removeAttribute("style");
          }
          return;
        }

        if (productObject.compare_at_price > productObject.price) {
          const priceDif = productObject.compare_at_price - productObject.price;
          const discount = Math.round(
            (priceDif * 100) / productObject.compare_at_price
          );

          this.discountMessage.innerText = `${discount}% OFF`;
          this.discountMessage.removeAttribute("style");
        } else {
          this.discountMessage.style.display = "none";
        }
      }

      updateProductUrl(productObject) {
        let newProductUrl = productObject.url;
        if (
          document.location.pathname.includes("/collections") &&
          !document.location.pathname.includes("/products")
        ) {
          newProductUrl = productObject.url.replace(
            "/products",
            `${document.location.pathname}/products`
          );
        }
        if (this.productUrl) {
          this.productUrl.forEach((url) => {
            url.href = newProductUrl;
          });
        }
      }

      updateProductQuickAdd(productObject) {
        if (productObject.options_with_values.length == 2) {
          const buttons = [];
          const options = [`<option value=""></option>`];

          productObject.variants.forEach((variant) => {
            buttons.push(`
          <li class="product-card__variant-option">
            <label for="product-option-${productObject.id}-${
              variant.options[1]
            }"
              ${variant.available ? "" : "data-disabled"}
            >
              <input
                id="product-option-${productObject.id}-${variant.options[1]}"
                value="${variant.id}"
                type="checkbox"
                class="product-card__option-value"
                data-product-name="${productObject.title}"
                data-variant-title="${variant.title}"
                data-variant-id="${variant.id}"
                tabindex="-1"
                ${variant.available ? "" : "disabled"}
              >
              ${variant.options[1]}
            </label>
          </li>
          `);
            options.push(`
            <option value="${variant.id}" ${
              variant.available ? "" : "disabled"
            }>${variant.title}</option>
          `);
          });

          this.variantButtonsContainer.innerHTML = buttons.join("");
          this.variantSelect.innerHTML = options.join("");

          this.quickAddForm.removeAttribute("style");
        } else {
          this.quickAddForm.style.display = "none";
        }
      }

      onOptionMouseEnter(evt) {
        const checkbox = evt.target.closest('input[type="checkbox"]');
        if (!checkbox || !this.variantButtonsContainer.contains(checkbox))
          return;

        clearTimeout(this.mouseLeaveTimeout);

        if (checkbox !== this.hoveredCheckbox) {
          this.hoveredCheckbox = checkbox;

          if (checkbox.disabled) {
            this.bisFormTrigger.setAttribute(
              "data-product-name",
              checkbox.dataset.productName
            );
            this.bisFormTrigger.setAttribute(
              "data-variant-title",
              checkbox.dataset.variantTitle
            );
            this.bisFormTrigger.setAttribute(
              "data-variant-id",
              checkbox.dataset.variantId
            );
            this.bisFormTrigger.removeAttribute("hidden");
          } else {
            this.bisFormTrigger.setAttribute("hidden", true);
          }
        }
      }

      onOptionMouseLeave(evt) {
        const checkbox = evt.target.closest('input[type="checkbox"]');

        if (!checkbox || !this.variantButtonsContainer.contains(checkbox))
          return;

        const related = evt.relatedTarget;

        if (!related || !checkbox.contains(related)) {
          this.hoveredCheckbox = null;
          this.mouseLeaveTimeout = setTimeout(() => {
            this.bisFormTrigger.setAttribute("hidden", true);
          }, 500);
        }
      }

      onBisTriggerClick(evt) {
        document.dispatchEvent(
          new CustomEvent("bisForm:open", {
            detail: {
              productTitle: this.bisFormTrigger.dataset.productTitle,
              variantTitle: this.bisFormTrigger.dataset.variantTitle,
              variantId: this.bisFormTrigger.dataset.variantId,
            },
          })
        );
      }

      onBisButtonMouseEnter(evt) {
        clearTimeout(this.mouseLeaveTimeout);
      }

      onBisButtonMouseLeave(evt) {
        this.bisFormTrigger.setAttribute("hidden", true);
      }

      onQuickAddSelectChange(evt) {
        evt.preventDefault();

        const id = evt.target.value;

        if (id) {
          window.store.dispatch(
            "addItems",
            {
              [id]: 1,
            },
            true
          );
          this.variantSelect.value = "";

          nostojs(api => {
            api.recommendedProductAddedToCart(id, this.recId);
          })
        }
      }

      onMediaMouseEnter(evt) {
        if(this.hoverVideo.classList.contains('active')) {
          this.hoverVideo.play();
        }
      }

      onMediaMouseLeave(evt) {
        if(this.hoverVideo.classList.contains('active')) {
          this.hoverVideo.pause();
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }

    }

    customElements.define("v3-product-card", V3ProductCards);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-suggestion"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('search-suggestions')) {
    class SearchSuggestions extends MenuDrawer {
      constructor() {
        super();
        this.summaryElement = this.querySelector("summary");
        this.input = this.querySelector("input");
        this.closeButton = this.querySelector("[data-search-close]");
        this.clearButton = this.querySelector("[data-search-clear]");
        this.debouncedSearchData = this.debounce(this.onType.bind(this), 500);
        this.form = this.querySelector(".nosto-search");
        this.form.querySelector("svg").addEventListener(
          "click",
          function () {
            this.form.submit();
          }.bind(this)
        );
        this.input.addEventListener(
          "input",
          function (event) {
            var search = this.debouncedSearchData();
          }.bind(this)
        );
        this.keywordContainer = this.querySelector(".search-suggestions__list");
        this.asideContainer = this.querySelector(".search-suggestions__aside");
        this.productsContainer = this.querySelector(".search-suggestions__grid");
        this.defaultKeywords = this.keywordContainer.innerHTML;
        this.defaultProducts = this.productsContainer.innerHTML;

        if (this.closeButton) {
          this.closeButton.addEventListener("click", this.onClose.bind(this));
        }

        if (this.clearButton) {
          this.clearButton.addEventListener("click", this.onClear.bind(this));
        }
      }

      debounce(mainFunction, delay) {
        let timer;
        return function (...args) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            mainFunction(...args);
          }, delay);
        };
      }
      onClose(event) {
        event.preventDefault();
        this.input.value = "";
        this.closeMenuDrawer(this.summaryElement);
      }
      onType() {
        nostojs((api) => {
          api
            .search(
              {
                query: this.input.value,
                products: {
                  fields: ["name", "price", "listPrice", "thumbUrl", "url"],
                  size: 6,
                },
                keywords: {
                  fields: ["keyword", "_highlight.keyword", "_redirect"],
                  highlight: {
                    preTag: "<b>",
                    postTag: "</b>",
                  },
                  size: 4,
                },
              },
              {
                track: "autocomplete",
              }
            )
            .then((response) => {
              this.updateResults(
                response.keywords,
                response.products,
                response.query
              );
            });
        });
      }
      updateResults(keywords, products, query) {
        var keywordInsert = "";
        if (keywords != null) {
          if (keywords.hits.length > 0) {
            keywords.hits.forEach((keywordItem) => {
              var buildUrl =
                window.location.origin +
                "/search?q=" +
                encodeURIComponent(keywordItem.keyword);
              if (keywordItem._redirect != null) {
                buildUrl = keywordItem._redirect;
              }
              keywordInsert += createKeywordLI(
                buildUrl,
                keywordItem._highlight.keyword
              );
            });
          } else if (query != "") {
            var buildUrl =
              window.location.origin + "/search?q=" + encodeURIComponent(query);
            keywordInsert += createKeywordLI(buildUrl, query);
          } else {
            keywordInsert = this.defaultKeywords;
          }
          if (
            keywords.hits.length == 0 &&
            products.hits.length == 0 &&
            query != ""
          ) {
            this.classList.add("no-results");
          } else {
            this.classList.remove("no-results");
          }
        } else if (query != "") {
          var buildUrl =
            window.location.origin + "/search?q=" + encodeURIComponent(query);
          keywordInsert += createKeywordLI(buildUrl, query);
        } else {
          keywordInsert = this.defaultKeywords;
        }
        this.keywordContainer.innerHTML = keywordInsert;
        var listItems = this.keywordContainer.querySelectorAll("li a");
        if (listItems.length > 0) {
          listItems.forEach((item) => {
            item.addEventListener("click", (e) => {
              e.preventDefault();
              var val = item.getAttribute("data-keyword");
              var link = item.getAttribute("href");
              nostojs((api) => {
                api.recordSearchClick("autocomplete", {
                  keyword: val,
                });
              });
              window.location.href = link;
            });
          });
        }
        var productsInsert = "";
        var defaultData = {
          listPrice: 58,
          name: "DEFAULT",
          price: 58,
          productId: "4350478188567",
          thumbUrl:
            "https://cdn.shopify.com/s/files/1/2445/4975/products/1210077_outerknown_GroovyPocketTee_TCT_f_pdp_copy_large.jpg?v=1695237788",
          url: "https://www.outerknown.com/products/groovy-pocket-tee-terra-cotta",
        };
        if (products != null) {
          if (products.hits.length > 0) {
            products.hits.forEach((productItem) => {
              productsInsert += createProductLI(productItem);
            });
          } else if (query != "") {
          } else {
            productsInsert = this.defaultProducts;
          }
        } else {
          productsInsert = this.defaultProducts;
        }
        this.productsContainer.innerHTML = productsInsert;
        var listItems = this.productsContainer.querySelectorAll("li a");
        if (listItems.length > 0) {
          listItems.forEach((item) => {
            item.addEventListener("click", (e) => {
              e.preventDefault();
              var val = item.getAttribute("data-id");
              var link = item.getAttribute("href");
              nostojs((api) => {
                api.recordSearchClick("autocomplete", {
                  productId: val,
                  url: link,
                });
              });
              window.location.href = link;
            });
          });
        }
        this.querySelector(".search-suggestions__container").scrollTop = 0;
        function createKeywordLI(link = "#", text, track = true) {
          var li = '<li class="search-suggestions__list-item p2 color-subdued">';
          li +=
            '<a data-keyword="' +
            text +
            '" href="' +
            link +
            '" class="full-unstyled-link" >' +
            text +
            "</a>";
          li += "</li>";
          return li;
        }

        function createProductLI(productData, track = true) {
          var li = '<li class="search-suggestions__grid-item">';
          li += '<div class="search-suggestions__item">';
          li +=
            '<a data-id="' +
            productData.productId +
            '" href="' +
            productData.url +
            '" class="search-suggestions__item-image full-unstyled-link">';
          li +=
            '<picture class="img"><img src="' +
            productData.thumbUrl +
            '" alt="" class="img__el" loading="eager"></picture>';
          li += "</a>";
          li += '<div class="search-suggestions__item-content">';
          li += '<p class="search-suggestions__item-title">';
          li +=
            '<a data-id="' +
            productData.productId +
            '" href="' +
            productData.url +
            '" class="full-unstyled-link">' +
            productData.name.replace('- FINAL SALE', '').replace('- SALE',  '') +
            "</a>";
          li += "</p>";
          if (current_iso == "US") {
            li +=
              '<p class="search-suggestions__item-meta p2">$' +
              productData.price +
              "</p>";
          }
          li += "</div>";
          li += "</div>";
          li += "</li>";
          return li;
        }
      }
    }

    customElements.define("search-suggestions", SearchSuggestions);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["site-feedback"] && !Shopify.designMode) return;
  try {
    class SiteFeedbackWidget extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.trigger = this.querySelector('.sfw-trigger');
      this.popup = this.querySelector('.sfw_pop');
      this.closeButton = this.querySelectorAll('[close-trigger]');
      this.form = this.querySelector('form');
      this.formTarget = 'https://hook.us1.make.com/vkrhj7gam09relssmvh8l53dop4xf8lu';
      this.botCheck = false;
      this.prompt = this.querySelector('#prompt');
      this.other = this.querySelector('#other');
      this.prompt.addEventListener(
        'change',
        function () {
          if (this.prompt.value == 'Other') {
            this.other.style.display = 'block';
            this.other.focus();
          } else {
            this.other.style.display = 'none';
          }
        }.bind(this)
      );
      this.trigger.addEventListener(
        'click',
        function () {
          this.popup.style.display = 'block';
          this.style.zIndex = '100';
          document.querySelector('#gorgias-chat-container').style.display = 'none';
        }.bind(this)
      );
      this.closeButton.forEach(
        function (icon) {
          icon.addEventListener(
            'click',
            function () {
              this.popup.style.display = 'none';
              this.style.zIndex = '2';
              document.querySelector('#gorgias-chat-container').style.display = 'block';
            }.bind(this)
          );
        }.bind(this)
      );
      this.form.addEventListener(
        'submit',
        function (event) {
          event.preventDefault();
          this.formSubmit();
        }.bind(this)
      );
      window.setTimeout(() => {
        this.botCheck = true;
      }, 5000);
    }
    formSubmit() {
      if (window.innerWidth > 768) {
        this.querySelector('#device-type').value = 'desktop';
      }
      var formData = new FormData(this.form);
      if (this.prompt.value == 'Other') {
        formData.set('prompt', this.other.value);
      }
      var currSelector = this;
      if (this.botCheck) {
        fetch(this.formTarget, {
          method: 'post',
          body: formData,
        }).then(function (data) {
          currSelector.querySelector('.completed_message').style.display = 'block';
          currSelector.form.style.display = 'none';
        });
      } else {
        currSelector.querySelector('.completed_message').style.display = 'block';
        currSelector.form.style.display = 'none';
      }
    }
  }
  customElements.define('site-feedback-widget', SiteFeedbackWidget);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trap-focus"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('trap-focus')) {

    class TrapFocus extends HTMLElement {
      constructor() {
        super();

        this.focusableSelectors = [
          'button:not([disabled]):not([tabindex="-1"])',
          '[href]',
          'input:not([disabled])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          '[tabindex]:not([tabindex="-1"])',
          '[contenteditable]'
        ]
      }

      connectedCallback() {
        this.abortController = new AbortController();

        this.addEventListener('keydown', this.handleKeyDown.bind(this), {
          signal: this.abortController.signal
        });

      }

      handleKeyDown(e) {
        if (e.key !== 'Tab') return;

        const focusableElements = Array.from(this.querySelectorAll(this.focusableSelectors))
          .filter(el => el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0);

        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      };

      disconnectedCallback() {
        this.abortController.abort();
      }

    }

    customElements.define('trap-focus', TrapFocus);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-product-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.slider = null;
        this.abortController = new AbortController();
        this.io = new IntersectionObserver(this.observerCallback.bind(this), {
          rootMargin: "100px",
          threshold: [0, 0.01, 0.02]
        })
        this.sliderContainer = this.querySelector('.product__gallery-media-container');
        this.zoomModal = this.querySelector('[data-zoom-modal]');
        this.productContainer = this.closest('[data-product-container]');
        this.videos = this.querySelectorAll('[data-video]');

        const imagesContainer = this.querySelector('[data-main-gallery-content]');
        const zoomImagesContainer = this.querySelector('[data-zoom-gallery-content]');

        if(imagesContainer) {
          this.images = Array.from(imagesContainer.content.cloneNode(true).children);
        }

        if(zoomImagesContainer) {
          this.zoomImages = Array.from(zoomImagesContainer.content.cloneNode(true).children);
        }

        this.initSlider();
        this.initVideosObserver();

        if(this.zoomModal) {
          this.zoomModal.addEventListener('click', this.onZoomModalClick.bind(this), {
            signal: this.abortController.signal
          });
          this.addEventListener('click', this.openZoomModal.bind(this), {
            signal: this.abortController.signal
          })
        }

        if(this.productContainer) {
          this.productContainer.addEventListener('pdp:product-change', this.onProductChange.bind(this), {
            signal: this.abortController.signal
          });
        }
      }

      initSlider() {
        if(this.querySelectorAll(".product__gallery-item").length == 0) return;

        this.slider = new tns({
          container: this.sliderContainer,
          items: 1,
          slideBy: 1,
          speed: 800,
          swipeAngle: 30,
          autoWidth: false,
          mouseDrag: true,
          loop: false,
          controls: false,
          preventScrollOnTouch: 'auto',
          navPosition: "bottom",
          responsive: {
            992: {
              disable: true,
              slideBy: 'page',
            }
          }
        })

        this.slider.events.on('indexChanged', (info) => {
          if(info.index == info.slideCount -1) {
            this.querySelector('.tns-inner').classList.add('end');
          } else {
            this.querySelector('.tns-inner').classList.remove('end');
          }
        })
      }

      initVideosObserver() {
        if(this.videos.length) {
          this.videos.forEach(video => {
            this.io.observe(video);
          })
        }
      }

      destroyVideosObserver() {
        if(this.videos.length) {
          this.videos.forEach(video => {
            this.io.unobserve(video);
          })
        }
      }

      openZoomModal(evt) {
        const target = evt.target.closest('button');

        if(target && target.dataset.imageRef) {
          this.zoomModal.showModal();
          this.switchZoomedImage(target.dataset.imageRef);
        }
      }

      onProductChange(evt) {
        const currentProduct = evt.detail.product;
        const colorOption = currentProduct.options.find((option) => {
          return option.name.toLowerCase() == 'color'
        })

        if(colorOption) {
          this.destroyVideosObserver();
          const newImages = this.images.filter(image => {
            return image.dataset.color == colorOption.values[0];
          })
          if(this.zoomModal) {
            if(this.zoomImages) {
              const newZoomImages = this.zoomImages.find(zoomContent => {
                return zoomContent.dataset.color == colorOption.values[0];
              })

              this.zoomModal.querySelector('.product__gallery-zoom-modal-content').replaceWith(newZoomImages);
            }
          }

          if(this.slider && this.slider.destroy) {
            this.slider.destroy();
          }

          this.sliderContainer = this.querySelector('.product__gallery-media-container');
          this.sliderContainer.innerHTML = ''

          newImages.forEach(image => {
            this.sliderContainer.appendChild(image);
          })

          this.initSlider();

          this.videos = this.querySelectorAll('[data-video]');
          this.initVideosObserver();
        }
      }

      onZoomModalClick(evt) {
        const target = evt.target.closest('button');

        if(target.classList.contains('product__gallery-zoom-image-button')) {
          this.switchZoomedImage.call(this, target.dataset.imageRef)
        }

        if(target.classList.contains('product__gallery-zoom-close')) {
          this.zoomModal.close();
        }
      }

      switchZoomedImage(imageRef) {
        this.zoomModal.querySelectorAll('[data-image-ref]').forEach((button) => {
          if(button.dataset.imageRef == imageRef) {
            button.classList.add('active');
            button.setAttribute('aria-expanded', true);
          } else {
            button.classList.remove('active');
            button.setAttribute('aria-expanded', false);
          }
        })

        this.zoomModal.querySelectorAll('[data-image]').forEach((image) => {
          if(image.dataset.image == imageRef) {
            image.classList.add('visible');
            image.scrollIntoView();
          } else {
            image.classList.remove('visible');
          }
        })
      }

      observerCallback(entries) {
        entries.forEach((entry) => {
          if(entry.isIntersecting) {
            entry.target.play();
          } else {
            entry.target.pause();
          }
        })
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
